export default {
  "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
}